<template>
    <div class="page-view">
        <tab-group></tab-group>
        <div class="section-wrapper">车辆和部门</div>
    </div>
</template>

<script>
    import TabGroup from "./tabGroup";

    export default {
        components: {
            TabGroup
        }
    };
</script>

<style lang="scss" scoped>
    .page-view {
        height: 100%;
    }

    .section-wrapper {
        height: calc(100% - 61px);
        padding: 0 20px;
    }
</style>
